export enum PayChangeTypeCv {
    approved = 159,
    rejected = 158
}
